const XIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7148 0.84375H16.4023L10.5273 7.55859L17.4375 16.7344H12.0234L7.78125 11.1797L2.92969 16.7344H0.234375L6.51562 9.5625L-0.117188 0.84375H5.4375L9.27344 5.92969L13.7148 0.84375ZM12.7734 15.1289H14.2617L4.66406 2.36719H3.07031L12.7734 15.1289Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default XIcon;
